import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(6),
}));
